import {gql} from "@apollo/client";

// Returns only success/message — the AI reply arrives asynchronously in the
// session's message list and must be picked up by polling the report.
export const AddOneAiChatMessage = gql`
    mutation AddOneAiChatMessage($oneAiChatSessionId: ID!, $input: OneAiChatMessageAttributeInput!) {
        addOneAiChatMessage(oneAiChatSessionId: $oneAiChatSessionId, input: $input) {
            success
            message
            errorCode
        }
    }
`;
